<template>
  <li>
    <div class="lead-panel">
      <label :for="`toggle-opportunity-${pkg.id}`">
        {{ pkg.name }}
      </label>
      <toggle-button
        :id="`toggle-opportunity-${pkg.id}`"
        :sync="true"
        v-model="pkg.opted_in"
        :labels="{ checked: 'Yes', unchecked: 'No' }"
        :color="{ checked: $brandPrimary, unchecked: '#b7b7b7' }"/>
    </div>

    <div style="padding: 1em;">
      <div v-if="pkg.opted_in && pkg.package_options.length > 1">
        Select package options
        <profile-talent-packages-list-item-option v-for="(option, index) in pkg.package_options" :option="option"
                                                  :key="option.id" :validation="validation.package_options.$each[index]"
                                                  class="packages-list-item" :user="user"/>
      </div>
      <div v-else-if="pkg.opted_in && pkg.package_options.length === 1">
        <profile-talent-packages-list-item-single-option :pkg="pkg" :validation="validation.package_options.$each[0]" :user="user"/>
      </div>
      <div v-if="!validation.mustSelectPackageOption" class="help-block">You must select at least one package option
      </div>
    </div>
  </li>
</template>

<script>
import ProfileTalentPackagesListItemOption from './ProfileTalentPackagesListItemOption'
import ProfileTalentPackagesListItemSingleOption from './ProfileTalentPackagesListItemSingleOption'
export default {
  components: {ProfileTalentPackagesListItemSingleOption, ProfileTalentPackagesListItemOption},
  props: {
    pkg: {
      required: true
    },
    validation: {
      required: true
    },
    user: {
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
  .lead-panel {
    background-color: white;
    display: flex;
    justify-content: space-between;
    padding: 1.5em 1em;
  }

  .packages-list-item {
    border-top: 1px solid mix(grey, #fff, 20%);

    &:last-child {
      border-bottom: 1px solid mix(grey, #fff, 20%);
    }
  }
</style>
